import { Button, Typography } from 'antd'
import './index.scss'
import { useNavigate } from 'react-router-dom'

const { Title } = Typography

export const JoinWaitingList = () => {
    const navigate = useNavigate()
    return (
        <section className="cta-container">
            <div className="cta-content">
                <div className="cta-text">
                    <Title level={1} className="cta-title">
                        Join the Moodra Community Today!
                    </Title>
                    <Button type="primary" size="large" className="waitlist-button" onClick={() => navigate('/contact-us')}>
                        Contact Us
                    </Button>
                </div>
                <div className="phone-container">
                    <img
                        src="/images/cta-visual.png"
                        alt="Moodra app welcome screen"
                    />
                </div>
            </div>
        </section>
    )
}

